module.exports = __webpack_public_path__ + "static/media/icon_kijkwijzer_al.8a5932cc.svg";